/**
 * Constants - App-wide constants for colors, icons, and configurations
 */

export const COLOR_PALETTE = {
  red: '#dc2626',
  orange: '#ea580c',
  amber: '#d97706',
  yellow: '#ca8a04',
  lime: '#65a30d',
  green: '#16a34a',
  teal: '#0d9488',
  cyan: '#0891b2',
  blue: '#2563eb',
  indigo: '#4f46e5',
  violet: '#5600ad', // Custom Brand Color (was #440089 in original)
  purple: '#7C3AED', // Custom Brand Color (was #7C3AED in original)
  fuchsia: '#c026d3',
  pink: '#db2777',
  rose: '#e11d48',
  black: '#000000'
};

export const TAILWIND_COLORS = Object.keys(COLOR_PALETTE);

export const CUSTOM_ICONS = [
  // Order Status Icons - Modern Heroicons v2 style
  { label: 'Shopping Bag (Ordered)', key: 'ordered', path: 'M15.75 10.5V6a3.75 3.75 0 10-7.5 0v4.5m11.356-1.993l1.263 12c.07.665-.45 1.243-1.119 1.243H4.25a1.125 1.125 0 01-1.12-1.243l1.264-12A1.125 1.125 0 015.513 7.5h12.974c.576 0 1.059.435 1.119 1.007zM8.625 10.5a.375.375 0 11-.75 0 .375.375 0 01.75 0zm7.5 0a.375.375 0 11-.75 0 .375.375 0 01.75 0z' },
  { label: 'Truck (Shipped)', key: 'shipped', path: 'M8.25 18.75a1.5 1.5 0 01-3 0m3 0a1.5 1.5 0 00-3 0m3 0h6m-9 0H3.375a1.125 1.125 0 01-1.125-1.125V14.25m17.25 4.5a1.5 1.5 0 01-3 0m3 0a1.5 1.5 0 00-3 0m3 0h1.125c.621 0 1.129-.504 1.09-1.124a17.902 17.902 0 00-3.213-9.193 2.056 2.056 0 00-1.58-.86H14.25M16.5 18.75h-2.25m0-11.177v-.958c0-.568-.422-1.048-.987-1.106a48.554 48.554 0 00-10.026 0 1.106 1.106 0 00-.987 1.106v7.635m12-6.677v6.677m0 4.5v-4.5m0 0h-12' },
  { label: 'Archive Box (Delivered)', key: 'delivered', path: 'M20.25 7.5l-.625 10.632a2.25 2.25 0 01-2.247 2.118H6.622a2.25 2.25 0 01-2.247-2.118L3.75 7.5M10 11.25h4M3.375 7.5h17.25c.621 0 1.125-.504 1.125-1.125v-1.5c0-.621-.504-1.125-1.125-1.125H3.375c-.621 0-1.125.504-1.125 1.125v1.5c0 .621.504 1.125 1.125 1.125z' },
  { label: 'Check Badge (Completed)', key: 'completed', path: 'M9 12.75L11.25 15 15 9.75M21 12c0 1.268-.63 2.39-1.593 3.068a3.745 3.745 0 01-1.043 3.296 3.745 3.745 0 01-3.296 1.043A3.745 3.745 0 0112 21c-1.268 0-2.39-.63-3.068-1.593a3.746 3.746 0 01-3.296-1.043 3.745 3.745 0 01-1.043-3.296A3.745 3.745 0 013 12c0-1.268.63-2.39 1.593-3.068a3.745 3.745 0 011.043-3.296 3.746 3.746 0 013.296-1.043A3.746 3.746 0 0112 3c1.268 0 2.39.63 3.068 1.593a3.746 3.746 0 013.296 1.043 3.746 3.746 0 011.043 3.296A3.745 3.745 0 0121 12z' },
  { label: 'Arrow Path (Returned)', key: 'returned', path: 'M16.023 9.348h4.992v-.001M2.985 19.644v-4.992m0 0h4.992m-4.993 0l3.181 3.183a8.25 8.25 0 0013.803-3.7M4.031 9.865a8.25 8.25 0 0113.803-3.7l3.181 3.182m0-4.991v4.99' },
  { label: 'X Circle (Cancelled)', key: 'cancelled', path: 'm9.75 9.75 4.5 4.5m0-4.5-4.5 4.5M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z' },
  { label: 'Trash (Delete)', key: 'trash', path: 'm14.74 9-.346 9m-4.788 0L9.26 9m9.968-3.21c.342.052.682.107 1.022.166m-1.022-.165L18.16 19.673a2.25 2.25 0 01-2.244 2.077H8.084a2.25 2.25 0 01-2.244-2.077L4.772 5.79m14.456 0a48.108 48.108 0 00-3.478-.397m-12 .562c.34-.059.68-.114 1.022-.165m0 0a48.11 48.11 0 013.478-.397m7.5 0v-.916c0-1.18-.91-2.164-2.09-2.201a51.964 51.964 0 00-3.32 0c-1.18.037-2.09 1.022-2.09 2.201v.916m7.5 0a48.667 48.667 0 00-7.5 0' },

  // Navigation & UI Icons
  { label: 'Chart Bar (Dashboard)', key: 'dashboard', path: 'M3 13.125C3 12.504 3.504 12 4.125 12h2.25c.621 0 1.125.504 1.125 1.125v6.75C7.5 20.496 6.996 21 6.375 21h-2.25A1.125 1.125 0 013 19.875v-6.75zM9.75 8.625c0-.621.504-1.125 1.125-1.125h2.25c.621 0 1.125.504 1.125 1.125v11.25c0 .621-.504 1.125-1.125 1.125h-2.25a1.125 1.125 0 01-1.125-1.125V8.625zM16.5 4.125c0-.621.504-1.125 1.125-1.125h2.25C20.496 3 21 3.504 21 4.125v15.75c0 .621-.504 1.125-1.125 1.125h-2.25a1.125 1.125 0 01-1.125-1.125V4.125z' },
  { label: 'Cube (Stock)', key: 'stock', path: 'M21 7.5l-9-5.25L3 7.5m18 0l-9 5.25m9-5.25v9l-9 5.25M3 7.5l9 5.25M3 7.5v9l9 5.25m0-9v9' },
  { label: 'Users (Customers)', key: 'customers', path: 'M15 19.128a9.38 9.38 0 002.625.372 9.337 9.337 0 004.121-.952 4.125 4.125 0 00-7.533-2.493M15 19.128v-.003c0-1.113-.285-2.16-.786-3.07M15 19.128v.106A12.318 12.318 0 018.624 21c-2.331 0-4.512-.645-6.374-1.766l-.001-.109a6.375 6.375 0 0111.964-3.07M12 6.375a3.375 3.375 0 11-6.75 0 3.375 3.375 0 016.75 0zm8.25 2.25a2.625 2.625 0 11-5.25 0 2.625 2.625 0 015.25 0z' },
  { label: 'Cog (Settings)', key: 'settings', path: 'M9.594 3.94c.09-.542.56-.94 1.11-.94h2.593c.55 0 1.02.398 1.11.94l.213 1.281c.063.374.313.686.645.87.074.04.147.083.22.127.324.196.72.257 1.075.124l1.217-.456a1.125 1.125 0 011.37.49l1.296 2.247a1.125 1.125 0 01-.26 1.431l-1.003.827c-.293.24-.438.613-.431.992a6.759 6.759 0 010 .255c-.007.378.138.75.43.99l1.005.828c.424.35.534.954.26 1.43l-1.298 2.247a1.125 1.125 0 01-1.369.491l-1.217-.456c-.355-.133-.75-.072-1.076.124a6.57 6.57 0 01-.22.128c-.331.183-.581.495-.644.869l-.213 1.28c-.09.543-.56.941-1.11.941h-2.594c-.55 0-1.02-.398-1.11-.94l-.213-1.281c-.062-.374-.312-.686-.644-.87a6.52 6.52 0 01-.22-.127c-.325-.196-.72-.257-1.076-.124l-1.217.456a1.125 1.125 0 01-1.369-.49l-1.297-2.247a1.125 1.125 0 01.26-1.431l1.004-.827c.292-.24.437-.613.43-.992a6.932 6.932 0 010-.255c.007-.378-.138-.75-.43-.99l-1.004-.828a1.125 1.125 0 01-.26-1.43l1.297-2.247a1.125 1.125 0 011.37-.491l1.216.456c.356.133.751.072 1.076-.124.072-.044.146-.087.22-.128.332-.183.582-.495.644-.869l.214-1.281z M15 12a3 3 0 11-6 0 3 3 0 016 0z' },

  // Action Icons
  { label: 'Plus Circle (Add)', key: 'add', path: 'M12 9v6m3-3H9m12 0a9 9 0 11-18 0 9 9 0 0118 0z' },
  { label: 'Plus (Increase)', key: 'plus', path: 'M12 4.5v15m7.5-7.5h-15' },
  { label: 'Minus (Decrease)', key: 'minus', path: 'M19.5 12h-15' },
  { label: 'Chevron Left (Back)', key: 'back', path: 'M15.75 19.5L8.25 12l7.5-7.5' },
  { label: 'Chevron Right (Advance)', key: 'advance', path: 'M8.25 4.5l7.5 7.5-7.5 7.5' },
  { label: 'Exclamation Triangle (Warning)', key: 'warning', path: 'M12 9v3.75m-9.303 3.376c-.866 1.5.217 3.374 1.948 3.374h14.71c1.73 0 2.813-1.874 1.948-3.374L13.949 3.378c-.866-1.5-3.032-1.5-3.898 0L2.697 16.126zM12 15.75h.007v.008H12v-.008z' },
  { label: 'Pencil Square (Edit)', key: 'edit', path: 'M16.862 4.487l1.687-1.688a1.875 1.875 0 112.652 2.652L10.582 16.07a4.5 4.5 0 01-1.897 1.13L6 18l.8-2.685a4.5 4.5 0 011.13-1.897l8.932-8.931zm0 0L19.5 7.125M18 14v4.75A2.25 2.25 0 0115.75 21H5.25A2.25 2.25 0 013 18.75V8.25A2.25 2.25 0 015.25 6H10' },
  { label: 'Check (Save)', key: 'save', path: 'M4.5 12.75l6 6 9-13.5' },
  { label: 'X Mark (Close)', key: 'close', path: 'M6 18L18 6M6 6l12 12' },

  // Payment Icons
  { label: 'Banknotes (Cash)', key: 'cash', path: 'M2.25 18.75a60.07 60.07 0 0115.797 2.101c.727.198 1.453-.342 1.453-1.096V18.75M3.75 4.5v.75A.75.75 0 013 6h-.75m0 0v-.375c0-.621.504-1.125 1.125-1.125H20.25M2.25 6v9m18-10.5v.75c0 .414.336.75.75.75h.75m-1.5-1.5h.375c.621 0 1.125.504 1.125 1.125v9.75c0 .621-.504 1.125-1.125 1.125h-.375m1.5-1.5H21a.75.75 0 00.75-.75v-.75m0 0H3.75m0 0h-.375a1.125 1.125 0 01-1.125-1.125V15m1.5 1.5v-.75A.75.75 0 003 15h-.75M15 10.5a3 3 0 11-6 0 3 3 0 016 0zm3 0h.008v.008H18V10.5zm-12 0h.008v.008H6V10.5z' },
  { label: 'Credit Card', key: 'creditcard', path: 'M2.25 8.25h19.5M2.25 9h19.5m-16.5 5.25h6m-6 2.25h3m-3.75 3h15a2.25 2.25 0 002.25-2.25V6.75A2.25 2.25 0 0019.5 4.5h-15a2.25 2.25 0 00-2.25 2.25v10.5A2.25 2.25 0 004.5 19.5z' },
  { label: 'Arrow Up Tray (Upload)', key: 'upload', path: 'M3 16.5v2.25A2.25 2.25 0 005.25 21h13.5A2.25 2.25 0 0021 18.75V16.5m-13.5-9L12 3m0 0l4.5 4.5M12 3v13.5' },
  { label: 'Funnel (Filter)', key: 'filter', path: 'M12 3c2.755 0 5.455.232 8.083.678.533.09.917.556.917 1.096v1.044a2.25 2.25 0 01-.659 1.591l-5.432 5.432a2.25 2.25 0 00-.659 1.591v2.927a2.25 2.25 0 01-1.244 2.013L9.75 21v-6.568a2.25 2.25 0 00-.659-1.591L3.659 7.409A2.25 2.25 0 013 5.818V4.774c0-.54.384-1.006.917-1.096A48.32 48.32 0 0112 3z' },

  { label: 'Arrow Up-Right (Trend Up)', key: 'trendUp', path: 'M4.5 19.5l15-15m0 0H8.25m11.25 0v11.25' },
  { label: 'Arrow Down-Right (Trend Down)', key: 'trendDown', path: 'M4.5 4.5l15 15m0 0H8.25m11.25 0V8.25' },

  // Sync Icons
  { label: 'Arrow Path (Sync)', key: 'sync', path: 'M16.023 9.348h4.992v-.001M2.985 19.644v-4.992m0 0h4.992m-4.993 0l3.181 3.183a8.25 8.25 0 0013.803-3.7M4.031 9.865a8.25 8.25 0 0113.803-3.7l3.181 3.182m0-4.991v4.99' },
  { label: 'Check Circle (Check)', key: 'check', path: 'M9 12.75L11.25 15 15 9.75M21 12a9 9 0 11-18 0 9 9 0 0118 0z' },
  { label: 'Table', key: 'table', path: 'M4 6h16M4 10h16M4 14h16M4 18h16' },
  { label: 'Cards', key: 'cards', path: 'M4 5a1 1 0 011-1h4a1 1 0 011 1v4a1 1 0 01-1 1H5a1 1 0 01-1-1V5zm10 0a1 1 0 011-1h4a1 1 0 011 1v4a1 1 0 01-1 1h-4a1 1 0 01-1-1V5zM4 15a1 1 0 011-1h4a1 1 0 011 1v4a1 1 0 01-1 1H5a1 1 0 01-1-1v-4zm10 0a1 1 0 011-1h4a1 1 0 011 1v4a1 1 0 01-1 1h-4a1 1 0 01-1-1v-4z' }
];

export const ICONS_MAP = CUSTOM_ICONS.reduce((acc, opt) => ({
  ...acc,
  [opt.key]: opt.path
}), {});

export const ORDER_STATUS_FLOW = ['ordered', 'shipped', 'delivered', 'completed'];

export const TERMINAL_STATUSES = ['cancelled', 'returned', 'deleted'];

export const ALL_STATUSES = [...ORDER_STATUS_FLOW, ...TERMINAL_STATUSES];

export const DEFAULT_SETTINGS = {
  logoUrl: 'https://placehold.co/40x40/6366f1/ffffff?text=LV',
  primaryColor: 'indigo',
  statusIcons: {
    ordered: 'ordered',
    shipped: 'shipped',
    delivered: 'delivered',
    completed: 'completed',
    cancelled: 'cancelled',
    returned: 'returned',
    deleted: 'trash',
    dashboard: 'dashboard',
    stock: 'stock',
    customers: 'customers',
    settings: 'settings',
    add: 'add',
    back: 'back',
    advance: 'advance',
    delete: 'trash',
    warning: 'warning',
    edit: 'edit',
    save: 'save',
    close: 'close',
    upload: 'upload',
    previous: 'back'
  },
  statusColors: {
    ordered: 'blue',
    shipped: 'purple',
    delivered: 'yellow',
    completed: 'green',
    cancelled: 'red',
    returned: 'orange',
    deleted: 'gray'
  }
};

export const DEFAULT_GENERAL_SETTINGS = {
  storeName: 'Lilac Valley CRM',
  currency: 'GBP'
};

export const DEFAULT_STOCK_SETTINGS = {
  oilCategories: ['Men', 'Women', 'Unisex'],
  bottleVariants: {
    male: ['30ml', '50ml', '100ml', 'tester'],
    female: ['30ml', '50ml', '100ml'],
    pockets: ['20ml'],
    testers: ['tester']
  },
  lowStockThresholds: {
    oils: 50,
    bottles: 10
  },
  inventoryLabels: {
    bottles: 'Bottles',
    oils: 'Oils'
  }
};

// Note: This uses gray as a neutral color since Tailwind classes can't be dynamic
// For theme-aware focus styles, use inline styles with the theme color from settings
export const FOCUSED_INPUT_STYLE = 'border-gray-400 focus:ring-2 focus:ring-offset-1 focus:ring-gray-500 focus:border-gray-500';
